<template>
  <div>
    <!--头部导航-->
    <header-nav :type="typeInfo.cn" :route-to="'/index/index_'+typeInfo.en+'/'+typeInfo.en+'_list_map'"/>
    <!--主体展示内容-->
    <div class="d-flex flex-wrap justify-content-between">
      <div v-for="(homestayItem,index) in homeStay" class="homestay-item mb-3"
           @mouseenter="homrstayIndex=index" @mouseleave="homrstayIndex=''" :key="index">
        <img v-lazy="ImgPreUrl+homestayItem.pic" alt="">
        <div v-show="homrstayIndex===index" class="hove-homestay">
          <h4>{{homestayItem.title}}</h4>
          <hr/>
          <router-link :to="'/index/index_'+typeInfo.en+'/'+typeInfo.en+'_detail/'+homestayItem.store_id"
                       class="text-warning">了解更多
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import HeaderNav from './HeaderNav'

  export default {
    name: 'RecommendHomestay',
    components:{HeaderNav},
    props: {
      homeStay: {
        type: Array,
        default: () => {
          return [];
        }
      },
      type: {}
    },
    data() {
      return {
        homrstayIndex: ''
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
      typeInfo() {
        switch (this.type) {
          case 'homestay':
            return {en: 'homestay', UPen: 'HOMESTAY', cn: '民宿'};
          case 'scenic':
            return {en: 'scenic', UPen: 'SCENIC', cn: '景区'};
          default:
            return {}
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .homestay-item {
    width: 32%;
    height: 300px;
    position: relative;
    img {
      width: 100%;
      height: 100%
    }
  }

  .hove-homestay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    hr {
      width: 60%;
      background: #fff;
      margin: 20px 0 10px 0;
    }
  }
</style>
